import React, { useState, useEffect } from 'react';

// ⚠️ APNA GOOGLE SCRIPT URL YAHAN PASTE KAREIN
const GOOGLE_SCRIPT_URL = "https://script.google.com/macros/s/AKfycbxJUuqoZwrAZqleKtM7r5nQMmKuaJ9qYO_99-TMq0CIracjp3ah5N8YSzlEfUXm1qtt/exec"; 

// --- READ ONLY QUESTION COMPONENT ---
const ReadOnlyQuestion = ({ qNo, eng, urdu, answer, details }) => (
  <div style={{ marginBottom: '20px', paddingBottom: '15px', borderBottom: '1px dashed #e5e7eb' }}>
    <div style={{ fontSize: '15px', fontWeight: '600', color: '#1f2937', marginBottom: '5px' }}>{qNo}) {eng}</div>
    <div style={{ fontSize: '16px', color: '#4b5563', marginBottom: '10px', textAlign: 'right', direction: 'rtl', fontFamily: "'Noto Nastaliq Urdu', serif" }}>{urdu}</div>
    
    <div style={{ 
      backgroundColor: answer === 'Yes' ? '#ecfdf5' : answer === 'No' ? '#fef2f2' : '#f3f4f6', 
      padding: '8px 12px', 
      borderRadius: '6px', 
      border: `1px solid ${answer === 'Yes' ? '#10b981' : answer === 'No' ? '#ef4444' : '#d1d5db'}`,
      display: 'inline-block',
      fontWeight: 'bold',
      color: answer === 'Yes' ? '#065f46' : answer === 'No' ? '#991b1b' : '#374151',
      fontSize: '14px'
    }}>
      Answer: {answer || 'Not Answered'}
    </div>

    {details && (
       <div style={{ marginTop: '10px', backgroundColor: '#f3f4f6', padding: '10px', borderRadius: '6px', fontSize: '14px', borderLeft: '4px solid #6b7280' }}>
         <strong>Details:</strong> {details}
       </div>
    )}
  </div>
);

// --- MAIN DASHBOARD COMPONENT ---
const EmployeeDashboard = () => {
  const [view, setView] = useState('list');
  const [selectedForm, setSelectedForm] = useState(null);
  const [submissions, setSubmissions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(GOOGLE_SCRIPT_URL);
        const data = await response.json();
        if (data.error) throw new Error(data.error);
        setSubmissions(Array.isArray(data) ? data.reverse() : []);
      } catch (err) {
        console.error("Error fetching data:", err);
        setError("Failed to load data. Please check your internet or script URL.");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const handleCardClick = (form) => {
    setSelectedForm(form);
    setView('detail');
  };

  const handleBack = () => {
    setSelectedForm(null);
    setView('list');
  };

  // --- STYLES ---
  const styles = {
    wrapper: { 
      backgroundColor: '#f3f4f6', 
      height: '100vh', 
      overflowY: 'auto', 
      padding: '20px', 
      fontFamily: "'Inter', sans-serif",
      boxSizing: 'border-box'
    },
    // List/Table Styles
    tableContainer: {
      backgroundColor: 'white',
      borderRadius: '12px',
      boxShadow: '0 4px 6px rgba(0,0,0,0.05)',
      overflow: 'hidden',
      marginBottom: '50px'
    },
    tableHeader: {
      backgroundColor: '#f9fafb',
      borderBottom: '2px solid #e5e7eb',
      display: 'grid',
      gridTemplateColumns: '0.5fr 2fr 2fr 1.5fr 1fr',
      padding: '15px 20px',
      fontWeight: 'bold',
      color: '#374151',
      fontSize: '14px',
      textTransform: 'uppercase'
    },
    tableRow: {
      display: 'grid',
      gridTemplateColumns: '0.5fr 2fr 2fr 1.5fr 1fr',
      padding: '15px 20px',
      borderBottom: '1px solid #f3f4f6',
      alignItems: 'center',
      cursor: 'pointer',
      transition: 'background 0.2s',
      color: '#1f2937',
      fontSize: '15px'
    },
    actionBtn: {
      backgroundColor: '#eff6ff',
      color: '#1e40af',
      padding: '6px 12px',
      borderRadius: '6px',
      border: 'none',
      fontSize: '13px',
      fontWeight: '600',
      cursor: 'pointer'
    },

    // Detail Styles
    container: { maxWidth: '850px', margin: '0 auto', backgroundColor: '#ffffff', boxShadow: '0 10px 25px rgba(0,0,0,0.1)', borderRadius: '12px', overflow: 'hidden', marginBottom: '50px' },
    formHeader: { display: 'flex', alignItems: 'center', gap: '20px', backgroundColor: '#ffffff', color: 'Black', padding: '25px', borderBottom: '5px solid #1e3a8a' },
    body: { padding: '30px' },
    sectionHeader: { fontSize: '18px', fontWeight: 'bold', color: '#1e3a8a', borderBottom: '2px solid #e2e8f0', paddingBottom: '10px', marginBottom: '20px' },
    infoRow: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: '15px', marginBottom: '30px', backgroundColor: '#f8fafc', padding: '20px', borderRadius: '8px', border: '1px solid #e5e7eb' },
    label: { fontSize: '12px', color: '#6b7280', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '4px' },
    value: { fontSize: '16px', fontWeight: 'bold', color: '#111827' },
    backBtn: { backgroundColor: '#4b5563', color: 'white', border: 'none', padding: '10px 20px', borderRadius: '6px', cursor: 'pointer', fontWeight: 'bold', marginBottom: '20px', display: 'flex', alignItems: 'center', gap: '5px' }
  };

  // --- RENDER: LIST VIEW ---
  if (view === 'list') {
    return (
      <div style={styles.wrapper}>
        <div style={{ marginBottom: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <h1 style={{ fontSize: '28px', fontWeight: '800', color: '#1f2937', margin: 0 }}>Job Applications</h1>
            <p style={{ color: '#6b7280', margin: '5px 0 0 0' }}>Total Candidates: {submissions.length}</p>
          </div>
          <button style={{backgroundColor: '#6528a9', color: 'white', padding: '10px 20px', border: 'none', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer'}} onClick={() => window.location.reload()}>Refresh Data</button>
        </div>

        {loading ? (
          <div style={{textAlign: 'center', padding: '50px', color: '#6b7280'}}>Loading...</div>
        ) : submissions.length === 0 ? (
          <div style={{textAlign: 'center', padding: '50px', color: '#6b7280', background: 'white', borderRadius: '12px'}}>No applications found.</div>
        ) : (
          <div style={styles.tableContainer}>
            {/* Table Header */}
            <div style={styles.tableHeader}>
              <div>#</div>
              <div>Full Name</div>
              <div>Position</div>
              <div>Date</div>
              <div>Action</div>
            </div>

            {/* Table Rows */}
            {submissions.map((sub, index) => (
              <div 
                key={index} 
                style={styles.tableRow}
                onClick={() => handleCardClick(sub)}
                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f9fafb'}
                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
              >
                <div style={{color: '#9ca3af', fontWeight: 'bold'}}>{submissions.length - index}</div>
                <div style={{fontWeight: '600'}}>{sub.name}</div>
                <div>
                  <span style={{backgroundColor: '#e0e7ff', color: '#3730a3', padding: '4px 10px', borderRadius: '12px', fontSize: '12px', fontWeight: 'bold'}}>
                    {sub.position}
                  </span>
                </div>
                <div style={{color: '#6b7280'}}>{sub.date}</div>
                <div>
                  <button style={styles.actionBtn}>View Details</button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    );
  }

  // --- RENDER: DETAIL VIEW ---
  const formData = selectedForm || {};

  return (
    <div style={styles.wrapper}>
      <button onClick={handleBack} style={styles.backBtn}>&larr; Back to List</button>
      
      <div style={styles.container}>
        {/* Header */}
        <div style={styles.formHeader}>
          <img src="/sowash.jpeg" alt="Logo" style={{ height: '70px', objectFit: 'contain' }} />
          <div>
            <div style={{fontSize: '18px', fontWeight: '500'}}>APPLICATION DETAILS</div>
            <div style={{fontSize: '12px', color: '#6b7280', marginTop: '4px'}}>Submitted: {formData.submittedAt || formData.date}</div>
          </div>
        </div>

        <div style={styles.body}>
          {/* Basic Info */}
          <div style={styles.infoRow}>
            <div><div style={styles.label}>Full Name</div><div style={styles.value}>{formData.name}</div></div>
            <div><div style={styles.label}>Position Applied</div><div style={styles.value}>{formData.position}</div></div>
            <div><div style={styles.label}>Date of Application</div><div style={styles.value}>{formData.date}</div></div>
          </div>

          {/* Section 1 */}
          <div style={{ marginBottom: '35px' }}>
            <div style={styles.sectionHeader}><span>1. Employment & Discipline</span></div>
            <ReadOnlyQuestion qNo="1" 
              eng="Have you ever been terminated or resigned due to disciplinary issues?" 
              urdu="کیا آپ کو کبھی نظم و ضبط کے مسئلے کی وجہ سے نوکری سے نکالا گیا یا استعفیٰ دینا پڑا؟" 
              answer={formData.q1} 
            />
            <ReadOnlyQuestion qNo="2" 
              eng="Have you ever had a conflict or serious complaint with any customer in the past?" 
              urdu="کیا ماضی میں آپ کا کسی کسٹمر کے ساتھ کوئی تنازعہ یا سنجیدہ شکایت رہی ہے؟" 
              answer={formData.q2} details={formData.q2_details} 
            />
            <ReadOnlyQuestion qNo="3" 
              eng="Have you ever faced any problem or conflict with your co-workers or team members?" 
              urdu="کیا آپ کو کبھی اپنے ساتھی ملازمین یا ٹیم ممبرز کے ساتھ کسی مسئلے یا تنازعے کا سامنا کرنا پڑا؟" 
              answer={formData.q3} details={formData.q3_details} 
            />
            <ReadOnlyQuestion qNo="4" 
              eng="Have you had any serious conflict or fight with your previous manager or supervisor?" 
              urdu="کیا آپ کا اپنے پچھلے منیجر یا سپروائزر کے ساتھ کوئی سنجیدہ تنازعہ یا جھگڑا ہوا تھا؟" 
              answer={formData.q4} 
            />
          </div>

          {/* Section 2 */}
          <div style={{ marginBottom: '35px' }}>
            <div style={styles.sectionHeader}><span>2. Work Commitment</span></div>
            <ReadOnlyQuestion qNo="5" 
              eng="Can you work six (6) days a week as per company requirement?" 
              urdu="کیا آپ کمپنی کی ضرورت کے مطابق ہفتے میں چھ (6) دن کام کر سکتے ہیں؟" 
              answer={formData.q5} 
            />
            <ReadOnlyQuestion qNo="6" 
              eng="Can you work extra hours during the day if required?" 
              urdu="کیا ضرورت پڑنے پر آپ اضافی اوقات میں کام کر سکتے ہیں؟" 
              answer={formData.q6} 
            />
            <ReadOnlyQuestion qNo="7" 
              eng="If you get a new job elsewhere, will you provide a minimum 30-day written notice before leaving?" 
              urdu="اگر آپ کو کہیں اور نوکری مل جائے، تو کیا آپ کمپنی چھوڑنے سے پہلے کم از کم 30 دن کا تحریری نوٹس دیں گے؟" 
              answer={formData.q7} 
            />
            <ReadOnlyQuestion qNo="8" 
              eng="Do you agree that in case you leave without notice, the company may withhold your salary?" 
              urdu="کیا آپ متفق ہیں کہ نوٹس پیریڈ کے بغیر نوکری چھوڑنے پر کمپنی تنخواہ روک سکتی ہے؟" 
              answer={formData.q8} 
            />
          </div>

          {/* Section 3 - Personal & General */}
           <div style={{ marginBottom: '35px' }}>
            <div style={styles.sectionHeader}><span>3. Personal & General Info</span></div>
            <ReadOnlyQuestion qNo="9" 
              eng="Any blood relative currently working in the company?" 
              urdu="کیا کمپنی میں آپ کا کوئی قریبی رشتہ دار کام کر رہا ہے؟" 
              answer={formData.q9} details={formData.q9_details} 
            />
            <ReadOnlyQuestion qNo="10" 
              eng="Do you own a smartphone?" 
              urdu="کیا آپ کے پاس ذاتی اسمارٹ فون ہے؟" 
              answer={formData.q10} 
            />
            <ReadOnlyQuestion qNo="11" 
              eng="Do you own a motorcycle?" 
              urdu="کیا آپ کے پاس موٹر سائیکل ہے؟" 
              answer={formData.q11} 
            />
            <ReadOnlyQuestion qNo="12" 
              eng="Do you own a car?" 
              urdu="کیا آپ کے پاس کار ہے؟" 
              answer={formData.q12} 
            />
            <ReadOnlyQuestion qNo="13" 
              eng="Can you climb stairs without difficulty?" 
              urdu="کیا آپ بغیر کسی مشکل کے سیڑھیاں چڑھ سکتے ہیں؟" 
              answer={formData.q13} 
            />
            <ReadOnlyQuestion qNo="14" 
              eng="Do you have any physical deformity, disability, or medical condition?" 
              urdu="کیا آپ کو کوئی جسمانی معذوری یا طبی مسئلہ ہے جو کام پر اثر انداز ہو سکتا ہو؟" 
              answer={formData.q14} details={formData.q14_details} 
            />
            <ReadOnlyQuestion qNo="15" 
              eng="Do you own a laptop or desktop computer?" 
              urdu="کیا آپ کے پاس ذاتی لیپ ٹاپ یا کمپیوٹر موجود ہے؟" 
              answer={formData.q15} 
            />
            <ReadOnlyQuestion qNo="16" 
              eng="Do you have any issue working at height (fear of height)?" 
              urdu="کیا آپ کو اونچائی پر کام کرنے میں کوئی مسئلہ یا ڈر ہے؟" 
              answer={formData.q16} 
            />
          </div>

          {/* Emergency Contacts Display */}
          <div style={{ marginBottom: '35px' }}>
            <div style={styles.sectionHeader}><span>4. Emergency Contacts</span></div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '20px' }}>
              <div style={{ backgroundColor: '#fafafa', padding: '20px', border: '1px solid #e5e7eb', borderRadius: '8px' }}>
                <div style={{fontWeight: 'bold', marginBottom: '15px', color: '#1e3a8a', borderBottom:'1px solid #ddd', paddingBottom:'5px'}}>Emergency Contact 1</div>
                <div style={{marginBottom:'5px'}}>Name: <strong>{formData.contact1_name}</strong></div>
                <div style={{marginBottom:'5px'}}>Rel: <strong>{formData.contact1_relation}</strong></div>
                <div>Phone: <strong style={{color: '#6528a9'}}>{formData.contact1_phone}</strong></div>
              </div>
              <div style={{ backgroundColor: '#fafafa', padding: '20px', border: '1px solid #e5e7eb', borderRadius: '8px' }}>
                <div style={{fontWeight: 'bold', marginBottom: '15px', color: '#1e3a8a', borderBottom:'1px solid #ddd', paddingBottom:'5px'}}>Emergency Contact 2</div>
                <div style={{marginBottom:'5px'}}>Name: <strong>{formData.contact2_name}</strong></div>
                <div style={{marginBottom:'5px'}}>Rel: <strong>{formData.contact2_relation}</strong></div>
                <div>Phone: <strong style={{color: '#6528a9'}}>{formData.contact2_phone}</strong></div>
              </div>
            </div>
          </div>
          
           {/* Section 5 - Other Info */}
           <div style={{ marginBottom: '35px' }}>
            <div style={styles.sectionHeader}><span>5. Other Info</span></div>
            <div style={{ marginBottom: '20px', padding: '15px', backgroundColor: '#f9fafb', borderRadius: '8px' }}>
                <div style={styles.label}>Q18: How do you like to spend your free time?</div>
                <div style={{marginTop: '5px', fontSize: '15px', color: '#374151'}}>{formData.q18 || 'N/A'}</div>
            </div>
            <ReadOnlyQuestion qNo="19" 
              eng="Do you play any sport or engage in physical activity?" 
              urdu="کیا آپ کوئی کھیل کھیلتے ہیں یا جسمانی سرگرمی میں حصہ لیتے ہیں؟" 
              answer={formData.q19} details={formData.q19_details} 
            />
            <ReadOnlyQuestion qNo="20" 
              eng="Are you married?" 
              urdu="کیا آپ شادی شدہ ہیں؟" 
              answer={formData.q20} 
            />
            <div style={{ marginBottom: '15px', marginTop: '15px', padding: '15px', backgroundColor: '#fef2f2', borderRadius: '8px', border: '1px solid #fee2e2' }}>
                <div style={styles.label}>Blood Group</div>
                <div style={{marginTop: '5px', fontSize: '18px', fontWeight: 'bold', color: '#991b1b'}}>{formData.q21 || 'N/A'}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmployeeDashboard;